"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrivateContentVeil = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const auth0_react_1 = require("@auth0/auth0-react");
const theme_1 = require("../../theme");
const common_styled_components_1 = require("../common-styled-components");
const styled_components_1 = __importDefault(require("styled-components"));
const VeilContainer = styled_components_1.default.div `
  width: 100%;
  display: flex;
  flex-direction: column;
`;
const Veil = styled_components_1.default.div `
  width: 100%;
  height: 140px;
  background-color: ${theme_1.theme.colors.grey(5)};
  border: 1px solid ${theme_1.theme.colors.grey(4)};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${theme_1.theme.spacing(2)};
  padding: ${theme_1.theme.spacing(4)};
`;
const VeilText = styled_components_1.default.div `
  color: ${theme_1.theme.colors.grey(2)};
  text-align: center;
`;
const PrivateContentVeil = ({ title, subTitle, children }) => {
    const { isAuthenticated, loginWithRedirect } = (0, auth0_react_1.useAuth0)();
    if (!isAuthenticated) {
        return ((0, jsx_runtime_1.jsxs)(VeilContainer, { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.GraphTitle, { children: title }), subTitle !== undefined ? ((0, jsx_runtime_1.jsx)(common_styled_components_1.GraphSubTitle, { children: subTitle })) : null, (0, jsx_runtime_1.jsxs)(Veil, { children: [(0, jsx_runtime_1.jsxs)(VeilText, { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.A, { onClick: (e) => {
                                        e.preventDefault();
                                        loginWithRedirect();
                                    }, style: { cursor: "pointer" }, children: "Log in" }), " ", "or subscribe to see more details."] }), (0, jsx_runtime_1.jsx)(common_styled_components_1.ButtonLikeA, { href: "https://calendly.com/info-53a/get-ahti-calculator-pro", target: "_blank", color: theme_1.theme.colors.blue, children: "Tell me more!" })] })] }));
    }
    return children;
};
exports.PrivateContentVeil = PrivateContentVeil;
